import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ icon, title, description, path, color = 'primary' }) => {
  const navigate = useNavigate();

  const colorClasses = {
    primary: 'bg-primary/10 text-primary hover:bg-primary/20',
    secondary: 'bg-secondary/10 text-secondary hover:bg-secondary/20',
    success: 'bg-success/10 text-success hover:bg-success/20',
    warning: 'bg-warning/10 text-warning hover:bg-warning/20',
    accent: 'bg-accent/10 text-accent-foreground hover:bg-accent/20'
  };

  return (
    <button
      onClick={() => navigate(path)}
      className="bg-card border border-border rounded-xl p-4 md:p-6 hover:shadow-lg transition-all duration-300 text-left w-full group"
    >
      <div className="flex items-start gap-4">
        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${colorClasses?.[color]} flex items-center justify-center flex-shrink-0 transition-all duration-300 group-hover:scale-110`}>
          <Icon name={icon} size={24} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>
        <Icon
          name="ChevronRight"
          size={20}
          className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all duration-300 flex-shrink-0"
        />
      </div>
    </button>
  );
};

export default QuickActionCard;